import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelNotasView from './PanelNotasView';
import * as ROUTES from '../../../../router/Routes';

const PanelNotasModule = () => {
  return (
    <ContainerTemplate active={ROUTES.notas} routes={[]}>
      <PanelNotasView />
    </ContainerTemplate>
  );
};

export default PanelNotasModule;
